/**
 * @fileoverview GET handler for the "/custom_objects/:type_name/:external_id/unlinked_users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdUnlinkedUsers } from "./constants";
import type {
  CustomObjectsTypeNameExternalIdUnlinkedUsersParams,
  CustomObjectsTypeNameExternalIdUnlinkedUsersResponse,
} from "./types";

export const getCustomObjectsTypeNameExternalIdUnlinkedUsers = reactQueryFetcherAdapter(
  customObjectsTypeNameExternalIdUnlinkedUsers,
  (
    signal: AbortSignal,
    {
      appGroupId,
      typeName,
      externalId,
      userIdentifier,
      pageNumber = 1,
    }: CustomObjectsTypeNameExternalIdUnlinkedUsersParams
  ): Promise<CustomObjectsTypeNameExternalIdUnlinkedUsersResponse> => {
    return fetch<CustomObjectsTypeNameExternalIdUnlinkedUsersResponse>(
      `/custom_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/unlinked_users`,
      "GET",
      {
        app_group_id: appGroupId,
        user_identifier: userIdentifier,
        page_number: pageNumber,
      },
      { signal }
    );
  }
);
